<script>
import { layoutComputed } from "@/state/helpers";
import Vertical from "./vertical";

export default {
  props: {
    pagetitle: {
      type: String,
      required: false,
    },
  },
  components: {
    Vertical,
  },
  data() {
    return {};
  },
  computed: {
    ...layoutComputed,
  },
  methods: {},
  mounted() {
    document.body.setAttribute("data-layout-mode", this.layoutMode);
  },
};
</script>

<template>
  <div>
    <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <router-view></router-view>
    </Vertical>
  </div>
</template>
